import AdviserInitialCharges from './AdviserCharges/InitialCharge';
import AdviserOngoingCharges from './AdviserCharges/OngoingCharge';
import NewCase from './Case/NewCase';
export const v2 = {
  NewCase,
  AdviserCharges: {
    Initial: AdviserInitialCharges,
    Ongoing: AdviserOngoingCharges
  }
};
